module.exports = __webpack_public_path__ + "img/sxxsh.e9bc214e.png";